import MediumEditor from 'medium-editor';

var Watermark = MediumEditor.Extension.extend({
    name: 'watermark',
    title: 'Marca de agua',
    watermarked: true,

    init: function () {
        this.button = this.document.createElement('button');
        this.button.classList.add('medium-editor-action');
        this.button.classList.add('watermark-button');
        var logoImage = this.document.createElement('img');
        logoImage.setAttribute("src", "static/img/logoBlanco.png");
        logoImage.setAttribute("width", "22px");

        this.button.append(logoImage);
        this.button.title = this.title;
        this.on(this.button, 'click', this.handleClick.bind(this));
    },

    getButton: function () {
        return this.button;
    },

    handleClick: function (event) {
        if(!this.isWatermarked()){
            this.activate();
        } else {
            this.deactivate();
        }
    },

    isActive: function () {
        return this.button.classList.contains('medium-editor-button-active');
    },

    deactivate: function () {
        this.watermarked = false;
        this.button.classList.remove('medium-editor-button-active');
        var pf = this._mainPf();
        if(!pf){
            return;
        }
        pf.classList.remove("watermarked");
    },
    
    activate: function () {
        this.watermarked = true;
        this.button.classList.add('medium-editor-button-active');
        var pf = this._mainPf();
        if(!pf){
            return;
        }
        pf.classList.add("watermarked");
    },

    _mainPf: function(){
        var pfs = this.document.getElementsByClassName("pf"),
            pf = pfs.length ? pfs[0] : null;
        return pf;
    },

    setInitialContent: function (content) {
        var body = (content.getElementsByTagName("body").length) ? content.getElementsByTagName("body")[0] : null;
        if(Array.from(body.classList).indexOf("watermarked") >= 0){
            this.activate();
        } else {
            this.deactivate();
        }
    },

    isWatermarked: function(){
        return this.watermarked;
    }

})

export default Watermark;